import { connect } from 'react-redux'

import LinkComponent from './component'

const LinkContainer = connect(
  // Map state to props
  (/*state*/) => ({}),
  // Map actions to dispatch and props
  {}
)(LinkComponent)

export default LinkContainer
